import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { OpportunityViewService } from '@app/opportunities/services/opportunity-view.service';
import { numberFromString } from '@app/shared/utils/common-utils';
import { getParentSnapshotData } from '@app/shared/utils/route-resolve-helpers';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { OpportunityDetailsComplete } from '../../opportunities-api.model';

@Injectable({ providedIn: 'root' })
export class OpportunityDetailsResolver
  implements Resolve<OpportunityDetailsComplete>
{
  constructor(private opportunityViewService: OpportunityViewService) {}

  public resolve(
    activeSnapshot: ActivatedRouteSnapshot
  ): Observable<OpportunityDetailsComplete> {
    const data = getParentSnapshotData(activeSnapshot.pathFromRoot, ':id');
    this.opportunityViewService.viewedOpportunityId = numberFromString(
      activeSnapshot.paramMap.get('id')
    );

    const isMSTeams = activeSnapshot.queryParams?.is_msteams;

    // Return all our data as joined Observables
    return this.opportunityViewService
      .getOpportunityDetails(this.opportunityViewService.viewedOpportunityId)
      .pipe(
        map(
          ({
            opportunity,
            hasExternalProvider,
            totalSkills,
            userCanEditOpportunity,
          }) => ({
            hasExternalProvider,
            // Set `isNative` value by checking whether the `mobile`
            // parameter is set on the route. It only has one potential
            // value, so there's no point in converting it to a number or
            // handling its value with any more care.
            isNative: activeSnapshot.queryParamMap.has('mobile'),
            // TODO: This is super gross, is there no better way to get grandparent data
            isBrowsePreviewView: data.isBrowsePreviewView || isMSTeams || false,
            opportunity,
            userCanEditOpportunity,
            totalSkills,
          })
        )
      );
  }
}
